/**
 * LCE-003 — Compatibility Product Renderer
 *
 * Visual layer only. Uses LERA.compatibility.getProductsForDevice(model),
 * then reuses LERA Product Card Premium via Section Rendering
 * (/products/{handle}?sections=lera-compatibility-card).
 *
 * No Search & Discovery. No collection filters. No new catalog scan/index.
 */
(function (global) {
  'use strict';

  var LERA = (global.LERA = global.LERA || {});
  if (LERA.compatibilityResults) return;

  var SECTION_KEY = 'lera-compatibility-card';

  function getEngine() {
    return LERA.compatibility || null;
  }

  function getRootPath() {
    if (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) {
      return global.Shopify.routes.root;
    }
    return '/';
  }

  function setStatus(el, text) {
    if (!el) return;
    el.hidden = !text;
    el.textContent = text || '';
  }

  function fetchCardHtml(handle) {
    var url = getRootPath() + 'products/' + encodeURIComponent(handle) + '?sections=' + SECTION_KEY;
    return fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('card_fetch_failed');
        return response.json();
      })
      .then(function (payload) {
        return payload && payload[SECTION_KEY] ? payload[SECTION_KEY] : '';
      });
  }

  function extractItem(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('.lera-product-grid__item') || doc.querySelector('.lera-product-card');
  }

  /**
   * @param {{ root: Element, model: string }} options
   */
  function render(options) {
    var engine = getEngine();
    var root = options && options.root;
    var model = options && options.model;
    if (!engine || !root || !model || typeof engine.getProductsForDevice !== 'function') {
      return Promise.resolve({ success: false, reason: 'unavailable' });
    }

    var panel = root.querySelector('[data-compatibility-results]');
    var grid = root.querySelector('[data-compatibility-results-grid]');
    var status = root.querySelector('[data-compatibility-results-status]');
    if (!panel || !grid) {
      return Promise.resolve({ success: false, reason: 'missing_dom' });
    }

    panel.hidden = false;
    grid.innerHTML = '';
    setStatus(status, 'Cargando accesorios compatibles…');

    var resolved = engine.getProductsForDevice(model);
    if (!resolved || !resolved.success) {
      setStatus(status, 'No se pudieron cargar los productos.');
      return Promise.resolve(resolved || { success: false, reason: 'resolver_failed' });
    }

    var handles = resolved.handles || [];
    if (!handles.length) {
      setStatus(status, 'No hay accesorios compatibles con ' + model + '.');
      return Promise.resolve(resolved);
    }

    setStatus(status, resolved.productIds.length + ' accesorios compatibles con ' + (resolved.model || model));

    return Promise.all(
      handles.map(function (handle) {
        if (!handle) return Promise.resolve(null);
        return fetchCardHtml(handle).catch(function () {
          return null;
        });
      })
    ).then(function (htmlParts) {
      var fragment = document.createDocumentFragment();
      htmlParts.forEach(function (html) {
        if (!html) return;
        var item = extractItem(html);
        if (item) fragment.appendChild(document.importNode(item, true));
      });
      grid.appendChild(fragment);

      if (!grid.children.length) {
        setStatus(status, 'No se pudieron mostrar los productos.');
      }

      return resolved;
    });
  }

  LERA.compatibilityResults = {
    version: 'LCE-003.1',
    render: render,
  };
})(typeof window !== 'undefined' ? window : this);
